"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReactIcon", {
  enumerable: true,
  get: function get() {
    return _ReactIcon["default"];
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Icon["default"];
  }
});
var _Icon = _interopRequireDefault(require("./Icon"));
var _ReactIcon = _interopRequireDefault(require("./ReactIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }